import  { withStyles } from '@material-ui/core';
import Tooltip from '../../../../components/common/StyledToolTip';
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const styles = theme => ({
    arrivedShipment:{
        fontStyle:"italic",
        opacity:"0.65",
        fontWeight:400,
    },
    alignMiddle:{
        verticalAlign:"middle",
    },
    computedIBETA:{
        fontSize:"15px"
    },
    printLabel: {
      color: theme.printTableLabel,
      opacity:"1",
      fontWeight:500,
    }
});

const IBETARenderer = (params) => {
  const { actualArrivalTime, isComputedIbeta, trailerActualArrivalTime } = params.data;
  const { classes } = params;
  const printLabelClass = params.showInPrint ? classes.printLabel: '';

  if (actualArrivalTime || trailerActualArrivalTime) {
    return <span className={`${classes.arrivedShipment} ${printLabelClass}`}> Arrived </span>;
  } else if (!actualArrivalTime && isComputedIbeta) {
    return (
      <>
        <span className={`${classes.alignMiddle} ${printLabelClass}`}>{params.valueFormatted} </span>
        {params.showInPrint ? (
          <span className={`${classes.arrivedShipment} ${printLabelClass}`}> RouteMAX ETA </span>
        ) : (
          <Tooltip title="RouteMAX ETA">
            <InfoOutlinedIcon
              className={`${classes.computedIBETA} ${classes.alignMiddle}`}
              color="primary"
            />
          </Tooltip>
        )}
      </>
    );
  }
  return <span className={printLabelClass}>{params.valueFormatted}</span>;
};

export default withStyles(styles)(IBETARenderer);